import React, { Component } from 'react'

class BrandOnboard extends Component {
	render() {
		return (
			<div>
				<h2>Create A New Brand</h2>
				<hr />
			</div>
		)
	}
}

export default BrandOnboard
